import React from 'react';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';

const styles = {};

const enhance = compose(
  withState('allowGapPayment', 'setAllowGapPayment', props => {
    return props.shop.shopDetail.allowGapPayment;
  })
);

const Main = enhance(
  ({
    classes,
    updateOpenChange,
    allowGapPayment,
    setAllowGapPayment,
    submitAction
  }) => {
    return (
      <div>
        <DialogContent style={{ padding: '50px 25px 20px', width: 450 }}>
          <Typography component="p" className={classes.description}>
            差額決済機能利用可否の設定を行います。
          </Typography>
          <RadioGroup
            value={allowGapPayment}
            onChange={e => {
              setAllowGapPayment(parseInt(e.target.value, 10));
            }}
          >
            <div>
              <FormControlLabel
                value={1}
                control={<Radio color="primary" />}
                label="可能 （券売機で営業または通販サービス）"
              />
            </div>
            <div>
              <FormControlLabel
                value={0}
                control={<Radio color="primary" />}
                label="不可（上記以外）"
              />
            </div>
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClickAction={() => updateOpenChange(false)}
            color="default"
          />
          <ChangeButton onClickAction={() => submitAction(allowGapPayment)} />
        </DialogActions>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
